module.exports = __webpack_public_path__ + "static/media/finals-3.9f4b803c.png";